
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Task } from '@/types';

@Component
export default class TaskResetDialog extends Vue {
  @Prop(Object) readonly task: Task | undefined;
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  // Sto aggiornando il Task
  get updating(): boolean {
    return this.$store.getters.isTaskUpdating;
  }

  onCancel() {
    this.dialog = false;
  }

  async onReset() {
    // Se è stato specificato un Task nell'inclusione di questo componente...
    if (this.task) {
      // ... aggiorna direttamente lo stato del Task specificato
      await this.$store.dispatch('updateTaskStatus', {
        task: this.task,
        status: null,
      });
    } else {
      // Altrimenti aggiorna il Task selezionato
      this.$store.dispatch('updateTaskFields', { status: null });
      await this.$store.dispatch('updateSelectedTask');
    }

    this.dialog = false;
  }
}
